module.exports = __webpack_public_path__ + "media/images/btn_to_payment-2d1249af77c2d2594d0035a6e3be6a8f.gif";